import React, { useEffect } from 'react'
import { useLoggedUser, useSessionPermission } from '@btime/react-session'
import { useMessagerActions, useNotification } from '@btime/react-messager'
import { useNativeNotification } from '../../../utils/hooks/nativeNotification'
import { useSimpleSocket } from '../../../utils/socket/socket'
import { useOpenServiceOrderModal } from '../../../utils/routes/modals/modalsActions'
import { serviceOrdersClient } from '../../../utils/apollo/api'

const ServiceOrderNotificationAlert = ({ children }) => {
  const hasNotificationAlertPermission = useSessionPermission('notificationAlert')
  const user = useLoggedUser()
  const native = useNativeNotification()
  const notify = useNotification()
  const { removeNotification } = useMessagerActions()
  const simpleSocket = useSimpleSocket('service_orders')
  const openDetailsModal = useOpenServiceOrderModal()

  useEffect(() => {
    if (!hasNotificationAlertPermission) {
      simpleSocket.off('insert')
      return
    }
    simpleSocket.on('insert', async data => {
      if (user.id === data.createdById) {
        return
      }
      const _onClick = () => {
        nativeNotification && nativeNotification.close()
        openDetailsModal(data)
        removeNotification(notId)
      }
      const _onClose = () => {
        nativeNotification && nativeNotification.close()
        removeNotification(notId)
      }
      const nativeNotification = native.notify({
        title: 'Há uma nova atividade',
        body: data.name || data.checklist.name,
        onClick: _onClick,
        onClose: _onClose
      })

      const notId = notify.warn({
        title: 'Há uma nova atividade',
        message: 'Clique no botão para visualizar.',
        fixed: true,
        onClose: _onClose,
        button: {
          label: 'Abrir',
          onClick: _onClick
        }
      })
      await serviceOrdersClient.refetchQueries({
        include: 'active'
      })
    })
  }, [native, notify, openDetailsModal, removeNotification, simpleSocket, hasNotificationAlertPermission, user.id])

  return <>{children}</>
}

export default ServiceOrderNotificationAlert
